const getters = {
  /* app */
  sidebar: state => state.app.sidebar,
  getSliderStateWidth: state => {
    return state.app.sidebar.sliderState === 'full' ? '260px' : '60px'
  },
  lockState: state => state.app.lock,
  /* permission */
  //permission_routers: state => state.permission.routers,
  permission_routers: state => state.user.menuList,
  addRouters: state => state.permission.addRouters,
  /* user */
  menuList: state => state.user.menuList,
  userInfo: state => state.user,
  areaList: state => state.user.areaList,
  userType: state => state.user.userType,
  userName: state => state.user.name,
}
export default getters
